export const STRIPE_TERMINAL_STATE_CHANGED = "stripe-terminal-state-changed";

export const NEEDS_STRIPE_TERMINAL = "needs-stripe-terminal";


// WEBPACK FOOTER //
// ./Features/Shared/events.js